<form class="disenrollment-form" [formGroup]="disenrollmentForm" (ngSubmit)="save()">
  <h2>Select the disenrollment patient's reason ({{ data.program.toUpperCase() }})</h2>
  <mat-form-field class="field" appearance="outline">
    <mat-label>Disenrollment Reason</mat-label>
    <mat-select formControlName="reason">
      <mat-option *ngFor="let option of disenrollmentOptions" [value]="option">{{ option }} </mat-option>
    </mat-select>
    <mat-hint>Please select a reason</mat-hint>
  </mat-form-field>

  <div class="disenrollment-form-buttons">
    <button mat-raised-button color="default" type="button" (click)="close()">Cancel</button>
    <button mat-raised-button color="primary" [disabled]="disenrollmentForm.invalid" type="submit">Save</button>
  </div>
  <mat-progress-bar *ngIf="loading" mode="indeterminate"> </mat-progress-bar>
</form>
